/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastVoxtralCorrectionsGet$Params {
  broadcastKey?: string;
  limit?: number;
  page?: number;
  size?: number;
  segment_type?: string;
  correction_types?: string;
}

export function apiBroadcastVoxtralCorrectionsGet(http: HttpClient, rootUrl: string, params?: ApiBroadcastVoxtralCorrectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralCorrectionsGet.PATH, 'get');
  if (params) {
    rb.query('broadcastKey', params.broadcastKey, {});
    rb.query('limit', params.limit, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('segment_type', params.segment_type, {});
    rb.query('correction_types', params.correction_types, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralCorrectionsGet.PATH = '/api/Broadcast/voxtral-corrections';
